import { render } from "./BigWhiteComponent2.vue?vue&type=template&id=e1c2e426&scoped=true"
import script from "./BigWhiteComponent2.vue?vue&type=script&lang=js"
export * from "./BigWhiteComponent2.vue?vue&type=script&lang=js"

import "./BigWhiteComponent2.vue?vue&type=style&index=0&id=e1c2e426&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c2e426"]])

export default __exports__